import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProvaScritta } from '../../../models/prova-scritta';

@Component({
    selector: '[add_doc_to_provascritta]',
  templateUrl: 'add-to-provascritta.component.html',
})

export class AddDocumentoToProvaScrittaComponent {
  @Input()
  provaScritta: ProvaScritta;

  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(provaScritta: ProvaScritta) {
    this.onClickAddToEntity.emit(provaScritta);
  }
}
